import React, {useEffect, useState} from 'react';
import {useController, useFieldArray, useForm} from "react-hook-form";
import CustomDatePicker from "../../base/components/forms/customDatePicker";
import FormHookInput from "../../air/airBooking/components/formHookInput";
import {Portlet, PortletBody, PortletFooter, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import LoadingButton from "../../base/components/loadingButton";
import {Button} from "reactstrap";
import GroupFormItem from "./groupFormItem";
import {Link, useParams} from "react-router-dom";
import axios from "../../../helpers/axios";
import moment from "moment";
import GoogleDisc from "../../../components/svg/GoogleDisc";
import _ from "lodash";
import SearchSelect from "../../../components/searchSelect";
import {RacoonGroupCreateRoute} from "../../routesConstants";
import {Tab, Tabs} from "react-bootstrap";
import BlackListItem from "./blackListItem";

export const tempCounterData = {
  counterparty:'',
  clientName:'',
  cashName:'',
  startSaldo:0
}

export const GROUP_RACOON_TYPE = ['Рабочий', 'Нужна корректировка', 'Черновик'];
export const GROUP_ROUTE_TYPE = [
  {label:"IATA Код",value:"iata",nameInObject :"description"},
  {label:"Города",value:"cities",nameInObject :"citiesRoute"},
  {label:"Город+код",value:"cities_iata",nameInObject :"citiesIataRoute"}];

const GroupForm = ({data, cb, edit, removeGroup, problems, fix}) => {
  const basicButton = {title:'Починить Google', variant: 'danger'}
  const [buttonSettings, setButtonSettings] = useState(basicButton)
  const [loading, setLoading] = useState(false)
  const formController = useForm({defaultValues:data})
  const [notification, setNotification] = useState(false)
  const [tabIndex, setTabIndex] = useState("counterparties");

  const { handleSubmit,
    register,
    formState:{errors},
    setValue,
    getValues,
    control} = formController
  const counterpartyControl = useFieldArray({
    control,
    name: `counterparties`,
    rules: {required: true},
    keyName: 'customId',
    defaultValue: data.counterparties
  });
  const blackListControl = useFieldArray({
    control,
    name: `blackList`,
    keyName: 'customId',
    defaultValue: data.blackList
  });
  const {
    field: { onChange: typeOnChange, value: typeValue }
  } = useController({
    name: `typeRacoon`,
    rules: { required: true },
    control,
    defaultValue: data.typeRacoon
  });
  const {
    field: { onChange: typeRouteOnChange, value: typeRouteValue }
  } = useController({
    name: `routeType`,
    rules: { required: true },
    control,
    defaultValue: data.routeType
  });
   const onSubmit = (data) =>{
     cb(data)
   }

   const addCounterparty = () =>{
     counterpartyControl.append(tempCounterData)
   }

   const addBlackName = () =>{
     blackListControl.append({lastName:'', firstName:''})
   }

   const universalDelete = (index, control,text) =>{
     if(window.confirm('Вы действительно хотите удалить '+text)){
       control.remove(index)
     }
   }

   const createNewBasedThis = () =>{
     if(window.confirm("Создать группу на основании этой")){
       const info = {...getValues()}
       delete info.id
       delete info.googleSheetId
       const newStart = moment(info.endDate, 'DD.MM.YYYY').add(1, 'day')
       info.startDate = newStart.format('DD.MM.YYYY')
       info.endDate = newStart.add(1,'year').format('DD.MM.YYYY')
       console.log(info)
       localStorage.setItem('groupCopied',JSON.stringify(info))
       window.open(window.location.protocol + "//" + window.location.host+RacoonGroupCreateRoute)
     }
   }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={'d-flex gap-2'}>
      <div style={{width:'35%'}}>
        <Portlet >
          <PortletHeader title={'Группа для сверки'} toolbar={edit && <PortletHeaderToolbar>
            <Button type={'button'}
                    size={'sm'}
                    onClick={createNewBasedThis}>Создать на основании</Button>
            <Button type={'button'}
                    size={'sm'}
                    color={'outline-danger'}
                    className={'d-flex align-items-center gap-2 ml-2'}
                    onClick={removeGroup}>
              <i className={"fa fa-trash"}/>
              <div>Удалить</div>
            </Button>
          </PortletHeaderToolbar>}/>
          <PortletBody className={'d-flex flex-column gap-3 h-100'}>
            <FormHookInput
              register={register(`name`, {required: true})}
              label={'Имя'}
              errors={errors}
            />
            <CustomDatePicker formController={formController}
                              value={data.startDate}
                              name={`startDate`}
                              rules={{required: true}}
                              cb={(date) => {
                                console.log('cb', moment(date).add(1, 'year'))
                                setValue('endDate', moment(date).add(1, 'year').format('DD.MM.YYYY'))
                              }}
                              label={'Дата начала'}/>
            <CustomDatePicker formController={formController}
                              value={data.endDate}
                              name={`endDate`}
                              rules={{required: true}}
                              label={'Дата окончания'}/>
            <SearchSelect label={'Тип cверки'}
                          onChange={(e) => {
                            typeOnChange(e)
                          }}
                          hasError={_.get(errors, `typeRacoon`)}
                          defaultValue={typeValue}
                          errors={errors}
                          array={GROUP_RACOON_TYPE.map(t => ({label: t, value: t}))}/>
            <SearchSelect label={'Тип маршрута'}
                          onChange={(e) => {
                            typeRouteOnChange(e)
                          }}
                          hasError={_.get(errors, `routeType`)}
                          defaultValue={typeRouteValue}
                          errors={errors}
                          array={GROUP_ROUTE_TYPE}/>
            <FormHookInput
              register={register(`googleSheetId`, {required: true})}
              label={'googleSheetId'}
              errors={errors}
            />
            <div>id-463@kayar-admin.iam.gserviceaccount.com</div>

          </PortletBody>
          <PortletFooter className={'d-flex justify-content-between align-items-center'}>
            <LoadingButton title={'Сохранить'} loading={false}/>
            {getValues().googleSheetId && <Link to={'https://docs.google.com/spreadsheets/d/'+getValues().googleSheetId} target={'_blank'}>
              <div className={'d-flex gap-2 pointer'}>
                <GoogleDisc/>
                <div>Таблица</div>
              </div>
            </Link>}
          </PortletFooter>
        </Portlet>
        {problems && problems.notInGoogle.length>0
          && <p className={'text-danger'}>В Google не хватает: {problems.notInGoogle.join(', ')}</p>}
        {problems && problems.notInKayar.length>0
          && <p className={'text-danger'}>У нас не хватает: {problems.notInKayar.join(', ')}</p>}
      </div>
      <div style={{width:'65%'}}>
        <Tabs
          variant="underline"
          id="controlled-tab-example"
          activeKey={tabIndex}
          onSelect={key => {
            setTabIndex(key)
          }}
        >
          <Tab eventKey="counterparties" title="Контрагенты" >
            <Portlet>
              <PortletHeader title={notification ? notification : 'Список контрагентов'} toolbar={<PortletHeaderToolbar>
                <div className={'d-flex gap-2'}>
                  <Button type={'button'} outline onClick={()=>{
                    try {
                      window.navigator.clipboard.writeText('id-463@kayar-admin.iam.gserviceaccount.com')
                        .then(() => {
                          setNotification('Email скопирован в буфер обмена')
                          setTimeout(() => {
                            setNotification(null)
                          }, 5000)
                        })
                    } catch (err){
                      setNotification('Не удалось скопировать. Скопируйте вручную : id-463@kayar-admin.iam.gserviceaccount.com')
                    }
                  }}> Скопировать почту </Button>
                  {problems && problems.notInGoogle.length>0 &&
                    <LoadingButton title={buttonSettings.title}
                                   type={'button'}
                                   variant={buttonSettings.variant}
                                   onClick={()=>{
                                     fix(()=>{
                                       setButtonSettings({title:'Успешно починено', variant:'success'})
                                       setTimeout(()=>{
                                         setButtonSettings(basicButton)
                                       }, 3000)
                                     })
                                   }}
                                   loading={loading}/>}

                  <Button onClick={addCounterparty}
                          type={'button'}>
                    Добавить
                  </Button>
                </div>
              </PortletHeaderToolbar>}/>
              <div className={'h-100'}>
                {counterpartyControl.fields.map((item,i)=>{
                  return <div key={item.customId}>
                    <div className={'bg-secondary p-2'} > Контрагент № - {i+1}</div>
                    <GroupFormItem formController={formController}
                                   removeItem={()=>universalDelete(i,counterpartyControl,' из списка контрагента?')}
                                   item={item}
                                   prefix={`counterparties[${i}]`}/>
                  </div>
                })}
              </div>
            </Portlet>
          </Tab>
          <Tab eventKey="blackList" title="Черный список">
            <Portlet>
              <PortletHeader title={'Черный список'} toolbar={<PortletHeaderToolbar>
                <Button onClick={addBlackName}
                        type={'button'}>
                  Добавить
                </Button>
              </PortletHeaderToolbar>}/>
              <div className={'h-100'}>
                {blackListControl.fields.map((item, i) => {
                  return <div key={item.customId}>
                    <div className={'bg-secondary p-2'}> Имя № - {i + 1}</div>
                    <BlackListItem formController={formController}
                                   removeItem={()=>universalDelete(i,blackListControl,' имя из черного списка?')}
                                   prefix={`blackList[${i}]`}/>
                  </div>
                })}
              </div>
            </Portlet>
          </Tab>
        </Tabs>
      </div>

    </form>
  );
};

export default GroupForm;
